import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
  AfterContentChecked,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'importer-siemens-energy-information-tag',
  templateUrl: './information-tag.component.html',
  styleUrls: ['./information-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, MatIcon, NgClass, MatTooltip]
})
export class InformationTagComponent implements AfterContentChecked {
  private readonly cdref = inject(ChangeDetectorRef);

  @ViewChild('valueText') valueText: ElementRef;

  @Input() titleText: string;
  @Input() value: string;
  @Input() icon?: string;
  @Input() titleIcon?: string;
  @Input() color: string;
  @Input() small?: boolean;
  @Input() tooltip?: string;
  @Input() setIconColor?: boolean;
  @Input() bigIcon?: boolean;
  @Input() big?: boolean;
  @Input() setIndicator = true;
  @Input() textColor = 'inherit';

  get isEllipsisActive(): boolean {
    const elem = this.valueText?.nativeElement;
    if (elem === undefined) return false;
    return elem.offsetWidth < elem.scrollWidth;
  }

  get onlyDisplayTitleIcon() {
    return !this.titleText && !this.setIndicator;
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
}
